import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: localStorage.getItem('admin') || null,
    isAuthenticated: !!localStorage.getItem('admin'),
    adminName: null, // Can be populated after parsing the token or fetching user profile
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoginSuccess: (state, action) => {
            state.token = action.payload.token;
            state.isAuthenticated = true;
            state.adminName = action.payload.name;
        },
        setLogout: (state) => {
            state.token = null;
            state.isAuthenticated = false;
            state.adminName = null;
            localStorage.removeItem('admin');
        },
    },
});

export const { setLoginSuccess, setLogout } = authSlice.actions;
export default authSlice.reducer;
